module.exports = __webpack_public_path__ + "img/SALE.16fd04f7.png";